'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeToSeconds = timeToSeconds;
function timeToSeconds(time) {
  if (typeof time === 'string') {
    var items = time.split(":");
    var t = 1;
    var secs = 0;
    for (var i = items.length - 1; i >= 0; i--) {
      secs += t * items[i];
      t *= 60;
    }
    return secs;
  } else {
    return time;
  }
}

var debug = exports.debug = location.hash === '#debug' ? function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  console.log.apply(console, args);
} : function () {};